define('modules/editor/views/edit_popup_body',['require','exports','module','base/collectionview','underscore','./propertybox'],function(require, exports, module) {
  "use strict";

  var CollectionView = require("base/collectionview"),
      _ = require("underscore"),
      PropertyBoxView = require("./propertybox");

  module.exports = CollectionView.extend({
    initialize: function(options) {
      this.vm = options.vm;
    },
    itemView: PropertyBoxView,
    collectionIterator: _.each,
    showNth: function(n) {
      _.each(this._childViews, function(cv) {
        cv.$el.hide();
        cv.triggerMethod("tab:hidden");
      });
      this._childViews[n].$el.show();
      this._childViews[n].triggerMethod("tab:shown");
    }
  });

});

